import { useReasonsQuery } from "@/app/reasons/reasons.api";
import React, { useEffect, useMemo, useRef, useState, type FC } from "react";

import { motion } from "framer-motion";

export type FAQEntryProps = {
  title: string;
  content: string;
};

export const FAQEntry: FC<FAQEntryProps> = ({ title, content }) => {
  const [visible, setVisible] = useState(false);
  const paragrapthContentRef = useRef<HTMLParagraphElement>();
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (visible) {
      const element = paragrapthContentRef.current;
      if (element) {
        setHeight(element.scrollHeight);
      }
    } else {
      setHeight(0);
    }
  }, [visible]);

  return (
    <div
      className="accordion border border-solid border-gray-300 p-4 rounded-md transition duration-500 accordion-active:bg-primary-50 accordion-active:border-primary-600 lg:p-4 active"
      id="basic-heading-one-with-icon"
    >
      <button
        onClick={() => setVisible((visible) => !visible)}
        className="accordion-toggle group inline-flex items-center justify-between text-left text-lg font-normal leading-8 text-gray-900 w-full transition duration-500 hover:text-primary-600 accordion-active:font-medium accordion-active:text-primary-600"
        aria-controls="basic-collapse-one-with-icon"
      >
        <h5>{title}</h5>
        <svg
          className="w-6 h-6 text-gray-900 transition duration-500 block accordion-active:text-primary-600 accordion-active:hidden group-hover:text-primary-600 origin-center"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12H18M12 18V6"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        <svg
          className="w-6 h-6 text-gray-900 transition duration-500 hidden accordion-active:text-primary-600 accordion-active:block group-hover:text-primary-600"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12H18"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
      <div
        id="basic-collapse-one-with-icon"
        className="accordion-content w-full overflow-hidden pr-4"
        aria-labelledby="basic-heading-one"
      >
        <motion.p
          className="text-base text-gray-900 font-normal leading-6"
          ref={paragrapthContentRef}
          animate={{ height }}
        >
          {content}
        </motion.p>
      </div>
    </div>
  );
};
